<ul
  ngbNav
  #nav="ngbNav"
  class="nav row flex-nowrap overflow-auto mb-2"
  [(activeId)]="activeKey"
>
  <li
    *ngFor="let cat of categories"
    [ngbNavItem]="cat.key"
    class="nav-item col-auto text-center"
  >
    <a ngbNavLink [innerHTML]="breakLabel(cat.value)"></a>
    <ng-template ngbNavContent>
      <ng-container
        *ngIf="getPartnersByCategory(cat.key).length; else noProviders"
      >
        <div class="table-responsive">
          <table class="table table-borderless align-middle mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Website</th>
                <th>Category</th>
                <th>Secondary Category</th>
                <th>Recommended</th>
                <th>Offers</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of getPartnersByCategory(cat.key)">
                <td>{{ p.name }}</td>
                <td>{{ formatAddress(p.address) }}</td>
                <td><a [href]="p.website" target="_blank">Website</a></td>
                <td>{{ getCategoryLabel(p.category) }}</td>
                <td>{{ getSecondaryLabels(p.secondaryCategory) }}</td>
                <td>{{ isRecommended(p) ? "Yes" : "No" }}</td>
                <td>
                  <ng-container *ngIf="getOffers(p).length; else noOffers">
                    <ul class="offer-list mb-0">
                      <li *ngFor="let o of getOffers(p)">
                        {{ o.offer }} -
                        <small class="text-white">{{ getExpirationLabel(o.days) }}</small>
                      </li>                      
                    </ul>
                  </ng-container>
                  <ng-template #noOffers>—</ng-template>
                </td>
                <td class="text-center">
                  <a (click)="openEdit(p)" class="action-pointer me-2">
                    <img
                      src="../../assets/images/edit-pen-icon.svg"
                      alt="Edit"
                    />
                  </a>
                  <a (click)="deletePartner.emit(p)" class="action-pointer">
                    <img
                      src="../../assets/images/delete-trash-icon.svg"
                      alt="Delete"
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #noProviders>
        <p class="text-muted m-3">
          No providers selected for {{ getCategoryLabel(cat.key) }}.
        </p>
      </ng-template>
    </ng-template>
  </li>

  <!-- the extra “Blocked” tab -->
  <li
    [ngbNavItem]="'blocked'"
    class="nav-item col-auto text-center"
    (click)="onCategoryChange('blocked')"
  >
    <a ngbNavLink>Blocked Providers</a>
    <ng-template ngbNavContent>
      <div *ngIf="blockedPartners?.length; else noneBlocked">
        <div class="table-responsive">
          <table class="table table-borderless align-middle mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Website</th>
                <th>Category</th>
                <th>Secondary Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let b of blockedPartners">
                <td>{{ b.name }}</td>
                <td>{{ formatAddress(b.address) }}</td>
                <td><a [href]="b.website" target="_blank">Website</a></td>
                <td>{{ getCategoryLabel(b.category) }}</td>
                <td>{{ getSecondaryLabels(b.secondaryCategory) }}</td>
                <td class="text-center">
                  <a
                    (click)="openUnblock(b)"
                    class="secondaryBtn action-pointer"
                  >
                    <img
                      src="../../assets/images/block-icon.png"
                      alt="Unblock"
                      class="me-2"
                    />
                    Unblock
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #noneBlocked>
        <p class="text-muted m-3">No blocked providers.</p>
      </ng-template>
    </ng-template>
  </li>
</ul>

<div class="mt-3" [ngbNavOutlet]="nav"></div>
